import i18next from 'i18next';

// Jazyk aplikácie -> locale pre formát dátumu (kód jazyka 'cz' nie je ISO, čeština je 'cs').
// sk/cz: 9. 10. 2026 12:32:23 · en: 10/9/2026, 12:32:23 PM
const LOCALES = { sk: 'sk-SK', cz: 'cs-CZ', en: 'en-US' };

export const appLocale = (lang = i18next.language) => LOCALES[lang] || LOCALES.cz;

export const formatDateTime = (value, lang) => (value ? new Date(value).toLocaleString(appLocale(lang)) : '');

export const formatDate = (value, lang) => (value ? new Date(value).toLocaleDateString(appLocale(lang)) : '');
